import { FC } from 'react';

import { Loader } from '@new/common/ui/Loader/Loader';

import { useCourseBuilder } from '../hooks/useCourseBuilder';
import { CompleteWizardPrompt } from '../components/CompleteWizardPrompt/CompleteWizardPrompt';
import { CourseBuilderLoadError } from '../components/CourseBuilderLoadError/CourseBuilderLoadError';
import { CourseBuilderWizard } from '../components/CourseBuilderWizard/CourseBuilderWizard';

export const CourseBuilderPage: FC = () => {
  const state = useCourseBuilder();

  switch (state.status) {
    case 'loading':
      return (
        <div className="p-4 sm:p-6">
          <Loader />
        </div>
      );
    case 'error':
      return (
        <div className="p-4 sm:p-6">
          <CourseBuilderLoadError onRetry={state.retry} />
        </div>
      );
    case 'wizard-incomplete':
      return (
        <div className="p-4 sm:p-6">
          <CompleteWizardPrompt />
        </div>
      );
    case 'ready':
      return <CourseBuilderWizard plans={state.plans} completedDegrees={state.completedDegrees} />;
  }
};
